import React from "react";
import codingicon from '../../images/codingicon.png';
import './logo.css'
export default function Logo()
{
    return(
        <img src={codingicon} className="coding-icon" alt=""></img>
    )
}